import { Route, Routes, useNavigate, useLocation } from "react-router-dom";
import Home from "./containers/home";
import { Amplify } from "aws-amplify";
import "@aws-amplify/ui-react/styles.css";
import FaceVerify from "./containers/faceVerify";
import Success from "./containers/success";
import NotFound from "./containers/notFound";
import LandingPage from "./containers/landingPage";
import "./styles/global.css";
import PrivacyAndPolicy from "./containers/privacy";
import TermsAndConditions from "./containers/termsAndConditions";
import Varified from "./containers/verified";
import UnVarified from "./containers/unVerified";
import Loading from "./containers/loadingScreen";
import ErrorPage from "./containers/error";
import awsconfig from "./awsConfig";
Amplify.configure(awsconfig);

function App() {
  const navigate = useNavigate();

  return (
    // <Authenticator>
    // {({ signOut, user }) => (
    <main>
      {/* <header>
              <h1>Welcome {user?.username}</h1>
              <button onClick={signOut}>Sign out</button>
            </header> */}

      <Routes>
        <Route path="/varification" element={<LandingPage />} />
        <Route path="/verification/:sessionId" element={<Home />} />
        <Route path="/privacy-policy" element={<PrivacyAndPolicy />} />
        <Route path="/terms-and-condition" element={<TermsAndConditions />} />
        <Route path="/verified" element={<Varified />} />
        <Route path="/error" element={<UnVarified />} />
        <Route path="/process/:sessionId" element={<FaceVerify />} />
        <Route path="/success" element={<Success />} />
        <Route path="/loading" element={<Loading />} />
        <Route path="/failed" element={<ErrorPage />} />
        <Route path="/404" element={<NotFound />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </main>
    //   )}
    // </Authenticator>
  );
}

export default App;
